import React from 'react';
import './GamePage.css';

import { Heading, Game, PageTitle } from '../../../components';
import { games } from '../../../constants';

const GamePage = () => { 

  return (

    <>

      {/* Page Title */}
      <PageTitle title={'競賽種類'} page={'Games'} />

      <section className='games'>

        {/* Section heading */}
        <Heading title={'競賽種類'} subTitle={'就在WRG世界機器人比賽'} />

        <div className='box-container'>

          {/* Map over the services array to render each service */}
          {games.map((game) => { 
            return (
              <Game key={game.id} game={game} />
            );
          })}
        </div>

      </section>

    </>

  )
}

export default GamePage;